// Rollbar stub - replaced with no-op, will be replaced with Sentry in the future
export const rollbar = {
  error: () => {},
  warning: () => {},
  info: () => {},
  debug: () => {},
  critical: () => {},
  configure: () => {},
};
